module.exports = __webpack_public_path__ + "img/dialog_done.34498923.svg";